import { useRef, type CSSProperties, type MouseEvent, type ReactNode } from "react";
import "./fx.css";

/**
 * ReactBits spotlight-card 포팅 (home-ui-spec §5.2·§8). onMouseMove →
 * CSS 변수 → radial-gradient. reduced-motion 시 미적용(fx.css) —
 * border 전환은 소비자 쪽 문법이 담당.
 */
export interface SpotlightCardProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  /** 스포트라이트 색 — 기본 골드 8% (§5.2 · reskin §4.2) */
  spotlightColor?: string;
  /** 반경 px (§5.2: 220) */
  radius?: number;
}

export function SpotlightCard({
  children,
  className,
  style,
  spotlightColor = "rgba(217,185,97,0.08)",
  radius = 220,
}: SpotlightCardProps) {
  const hostRef = useRef<HTMLDivElement>(null);

  const onMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    const el = hostRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty("--fx-spot-x", `${e.clientX - rect.left}px`);
    el.style.setProperty("--fx-spot-y", `${e.clientY - rect.top}px`);
  };

  return (
    <div
      ref={hostRef}
      className={`ty-fx-spot-host ${className ?? ""}`}
      onMouseMove={onMouseMove}
      style={
        {
          ...style,
          "--fx-spot-color": spotlightColor,
          "--fx-spot-r": `${radius}px`,
        } as CSSProperties
      }
    >
      {children}
      <span aria-hidden className="ty-fx-spot" />
    </div>
  );
}
